import { createBlueprint as e } from "@made-people/blueprint";
import { c as o, a as n } from "./blueprint-c4304960.mjs";
const r = e({
  slots: {
    base: "grid-rows-[max-content_max-content_max-content_1fr_max-content] grid-cols-[auto_1fr_max-content] grid w-[420px] mb-6 items-center [&>svg]:stroke-black w-full",
    name: "col-start-2 col-end-3 row-start-1 row-end-2 flex mb-1 text-label-sm",
    metaData: "col-start-2 col-end-3 row-start-3 row-end-4 text-label-sm mb-1 line-clamp-3 lg:line-clamp-2 text-text-less-emphasis-2",
    image: "w-full object-cover bg-neutral-100 h-full rounded-md",
    imageWrapper: "col-start-1 col-end-2 row-span-4 flex relative aspect-product-image mr-4 rounded-md bg-neutral-100 h-[118px] justify-center items-center",
    priceWrapper: "col-start3 col-end-4 row-start-1 row-end-2 flex flex-col mb-1 justify-end text-label-sm uppercase font-secondary",
    price: "",
    oldPrice: "",
    // Quantity picker
    quantityPickerWrapper: "row-start-4 row-end-5 col-start-2 col-end-3 flex gap-2 items-center text-label-sm self-end border border-border-light w-fit rounded-md",
    quantityPickerValue: "text-label-sm",
    quantityValue: "",
    // Remove button
    removeButton: "col-start-3 col-end-4 row-start-4 row-end-5 flex justify-end text-label-sm text-text-body self-end"
  },
  variants: {}
});
export {
  o as cartItemOsakaStyling,
  r as cartItemStyling,
  n as cartItemTokyoStyling
};
//# sourceMappingURL=index-blueprint.es.js.map
